// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/@pmmmwh/react-refresh-webpack-plugin/client/ReactRefreshEntry.js");
__webpack_require__("./node_modules/@roots/bud-client/lib/hmr/index.cjs?name=bud&bud.overlay=true&bud.indicator=true&path=/__bud/hmr");
__webpack_require__("./node_modules/@roots/bud-client/lib/proxy-click-interceptor.cjs");
__webpack_require__("./node_modules/react-refresh/runtime.js");
__webpack_require__(813);
var __webpack_exports__ = __webpack_require__("./resources/styles/app.css");
